module.exports = __webpack_public_path__ + "img/cross.5f01e89d.svg";